<div class="tabs__grid-item">
  <interconnect-summary
    [service]="service()"
    [subscriptionInstanceId]="interconnect().subscriptionInstanceId ?? undefined"
    [showTraffic]="true"
    style="width: 100%"
  />
</div>
